import { render, staticRenderFns } from "./BatchProduction.vue?vue&type=template&id=20f630c4"
import script from "./BatchProduction.vue?vue&type=script&lang=js"
export * from "./BatchProduction.vue?vue&type=script&lang=js"
import style0 from "./BatchProduction.vue?vue&type=style&index=0&id=20f630c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports